<template>
  <div style="padding-top: 3vw;">
    <bulletFrame :title="title" :name="name"></bulletFrame>
    {{time}}
    <picke @child-method="parentMethod"></picke>

  </div>
</template>
<script>
export default {
  data() {
    return {
       time:'',
       title:'什么是QT间期？',
       name:'QT间期代表心室去极化和复极化过程的总时程，测定值随年龄和性别而变化。QT间期与心率快慢有密切关系，正常人心率加速则QT间期缩短，反之则延长。QT改变在临床心电图诊断上具有重要价值，特别是QT延长对预报恶性心室律失常和心脏性猝死有重要意义。'
    };
  },
  components: {
    bulletFrame: () => import('@/components/bulletFrame'),
    picke: () => import('@/components/picke')
  },
  computed: {
	},
  mounted() {
  },
  beforeCreate() {
  },
  methods: {
    parentMethod(msg) {
      this.time = msg
    }
  },
};
</script>
<style scoped>
* {
  margin: 0 auto;
  padding: 0;
  font-family: "微软雅黑";
}

</style>


// WEBPACK FOOTER //
// src/views/picke.vue